module.exports = __webpack_public_path__ + "media/images/type1-b11d870379dd9a0fe467558f371ab679.png";